import { faqSchema } from '../../../constants/componentStaticData';
import { FaqComponent } from '../../Common/FAQS';
import { OrderedList } from '../OrderedList';

const ifscCodeSearch = [
  'Amount of remittance',
  'Bank’s account number',
  'Bank name of the receiver',
  'Name of the receiver',
  'Account number of the receiver',
  'Receiver’s bank branch’s IFSC code',
];
const stepsToOpen = [
  'One must be a citizen of India.',
  'The individual should be 18 years and above to meet eligibility.',
  'In the case of minors, the parents or the legal guardians of the minor can open the account on behalf of the minor.',
  'The applicant is required to have valid proof of identity and address proof that is Government recognised and approved.',
  'Further to the above criteria and approval from the bank, the applicant must make an initial deposit which depends on the account type and minimum balance requirement for that particular savings account that has chosen.',
];
const stepsToOpen2 = [
  'Proof of identity – Aadhaar Card, Passport, Driving license, Voter’s ID card,',
  'Proof of address -Aadhaar Card, Passport, Driving license, Voter’s ID card,',
  'PAN card',
  'Form 16 (only if PAN card is not available)',
  'Recent passport size photographs',
];
const informationReq = [
  'Amount you want to transfer',
  'Your Bank Account number',
  "Receiver's full name, bank name & account number",
  "Receiver's bank branch IFSC code",
];
interface contentProps {
  bankName: string;
}

export const ContentBankIndividualsComponent = ({
  bankName,
}: contentProps): JSX.Element => {
  const BankFAQS: Array<{
    header: string;
    content: React.ReactElement | string;
  }> = [
    {
      header: `What is the eligibility criteria for opening a bank account in ${bankName}?`,
      content: (
        <p>
          Eligibility criteria for opening an account in {bankName} is - Any
          Indian citizen of age 18 and above, who must have applicant with valid
          proof of identity which must be recognised and approved by the Indian
          Government
        </p>
      ),
    },
    {
      header: `What are the documents required for opening an account in ${bankName}?`,
      content: (
        <p>
          Documents required for opening {bankName} account is - Identity proof,
          Address proof, PAN card, Recent passport size photographs
        </p>
      ),
    },
    {
      header: `What is the information required for transferring funds using ${bankName} ?`,
      content: (
        <div>
          <p>
            Information required for transferring funds using {bankName} is :
          </p>
          <OrderedList list={informationReq} />
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="py-6">
        <span className="anchor" id="ifsccode"></span>
        <h2 className="text-s-40 sm:text-s-20">{bankName} IFSC Codes</h2>
        <p className="my-4">
          Let us understand what is IFSC. IFSC stands for “Indian Financial
          System Code”. It is an alphanumeric code that is assigned to each
          branch of a bank. IFSC is a unique identification number and is
          essential for any form of money transfer between banks. {bankName}{' '}
          IFSC code consists of eleven digit code which comprises of first four
          letters as ‘xxxx’, the fifth digit is 0 followed by the last 6 digits
          which represent the specific {bankName} branch code. Here’s an
          example, the IFSC code of the SBI branch at 11, Ganesh House, MG Road,
          Bangalore, is SBIN0007587. Here, 007587 is the branch code.
        </p>
      </div>
      <div className="py-6">
        <span className="anchor" id="ifsccodesearch"></span>
        <h2 className="text-s-40 sm:text-s-20">{bankName} IFSC Code Search</h2>
        <p className="my-4">
          Some easy and quick ways to find the IFSC codes of your bank is to
          search for it on the chequebook or the front page of your bank
          passbook. An IFSC code is essential for any mode of money transfers
          such as RTGS, NEFT & IMPS. It is impossible to conduct any money
          transfer without an IFSC code. Before you initiate a transfer, one
          must have the details of the receiver such; the name of the account
          holder, bank, branch and IFSC code of the respective bank branch. The
          Information required for Transferring Funds Using Any Mode of Payment
        </p>
        <OrderedList list={ifscCodeSearch} />
      </div>
      <div className="py-6">
        <span className="anchor" id="steps"></span>
        <h2 className="text-s-40 sm:text-s-20">
          Steps to Open {bankName} Account
        </h2>
        <p className="my-4">
          People can open various types of bank accounts - for business and
          personal purposes to transact, save and earn interest on deposits and
          be secured financially. To be eligible to open an account with{' '}
          {bankName}, customers need to meet certain criteria as mentioned
          below.
        </p>
        <OrderedList list={stepsToOpen} />
        <p className="my-4">
          The following documents are required for account opening:
        </p>
        <OrderedList list={stepsToOpen2} />
      </div>
      <div className="py-6">
        <span className="anchor" id="faqs"></span>
        <FaqComponent FAQS={BankFAQS} />
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(faqSchema(BankFAQS)),
        }}
      ></script>
    </>
  );
};
